import { get, BaseUrl, } from './api'
export const getLanguages = async () => {
    return await get(`api/Language/`,
        BaseUrl.Centerpoint);
}